import { useSelector, shallowEqual } from "react-redux";
import { useCallback } from "react";

export const useSettings = () => {
    const settings = useSelector(
        (store) => store.app.settings || {},
        shallowEqual
    );

    const getSettingValue = useCallback(
        (key, defaultValue = null) => {
            if (!settings.hasOwnProperty(key)) {
                // Agar setting defined hi nahi hai, to defaultValue return karo
                return defaultValue;
            }

            const value = settings[key];

            if (value === 'true') return true;
            if (value === 'false') return false;

            return value;
        },
        [settings]
    );

    return { getSettingValue, settings };
};
